<div class="d-flex align-items-right parent">
    <button class="btn openSearch" [ngClass]="isOpen ? 'button-translate' : 'button-not-translate'">
        <div *ngIf="!isOpen" [ngClass]="showEnvWarning ? 'icon fill-white' : ''"  [inlineSVG]="'assets/ico/search.svg'" alt="search icon" (click)="openSearch()"
            ngbTooltip="{{'buttons.quickSearch' | translate}}" tooltipClass="animation-tooltip" placement="bottom"
            container="body" triggers="hover"></div>
    </button>

    <div ngbDropdown placement="bottom-left" [ngClass]="!isOpen ? 'ngbDropdown-translate' : 'ngbDropdown'">
        <div [ngClass]="isOpen ? 'div-translate' : 'div-not-translate'">
            <form autocomplete="off">
                <input class="search-input form-control" [ngClass]="showEnvWarning ? 'white-input' : ''" type="text" name="quick-search" id="quick-search"
                    [placeholder]="'buttons.quickSearch' | translate" [(ngModel)]="searchValue"
                    (ngModelChange)="isLoading=true; orders=[]; projects=[]; this.quickSearch.next({ value: $event })">
            </form>
            <div *ngIf="isOpen && isLoading && searchValue.length > 0" class="ng-spinner-loader"></div>
            <div ngbDropdownMenu aria-labelledby="quick-search" [ngClass]="searchValue.length > 0 ? 'show' : ''"
                class="scrollable-menu" role="menu" placement="bottom-left" style="width: max-content;">
                <div class="section-name" *ngIf="searchValue.length > 0 && !isLoading" style="cursor: default;">ORDERS
                </div>
                <div *ngIf="orders.length === 0 && searchValue.length > 0 && !isLoading" class="no-data">
                    <div class="data-row">No Orders Found</div>
                </div>
                <div ngbDropdownItem *ngFor="let res of orders">
                    <div class="menu-button" (click)="redirect(res.identifier, 'order')">
                        <div class="data-row"
                            [innerHTML]="res.code + ' - ' + res.name + ' - (' + res.customerName + ')' | highlight: searchValue">
                        </div>
                    </div>
                </div>
                <div *ngIf="searchValue.length > 0 && !isLoading" class="section-name mt-3" style="cursor: default;">PROJECTS
                </div>
                <div *ngIf="projects.length === 0 && searchValue.length > 0 && !isLoading" class="no-data">
                    <div class="data-row">No Projects Found</div>
                </div>
                <div ngbDropdownItem *ngFor="let res of projects">
                    <div class="menu-button" (click)="redirect(res.identifier, 'project')">
                        <div class="data-row" [innerHTML]="res.jiraKey + ' - ' + res.name | highlight: searchValue">
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn closeSearch" (click)="closeSearch()">
                <div [inlineSVG]="'assets/ico/clear-button.svg'" [ngClass]="showEnvWarning ? 'fill-white' : ''"  class="icon icon-black clear-search-icon" alt="clear">
                </div>
            </button>
        </div>
    </div>
    <div class="blocker"></div>
</div>